<template>
  <div>
    <div class="py-3"></div>
    <v-card class="mx-auto" max-width="95%">
      <v-overlay :value="loading" absolute opacity="0.7">
        <v-progress-circular indeterminate size="48" />
      </v-overlay>
      <v-toolbar color="light-blue darken-3" dark>
        <v-toolbar-title>쿠폰 카테고리 관리</v-toolbar-title>
        <v-spacer />
        <v-btn color="white" outlined @click="loadCategories" :disabled="loading">
          <v-icon left>mdi-refresh</v-icon>
          새로고침
        </v-btn>
      </v-toolbar>

      <v-card-text class="pa-0">
        <v-alert type="info" text dense class="ma-3 mb-0">
          <span class="text-body-2">
            수정 가능한 항목은 <strong>표시명</strong>과 <strong>정렬</strong> 두 가지입니다.
            다우 원본명과 상태는 다우기술 동기화가 관리하므로 수정할 수 없습니다.
          </span>
        </v-alert>

        <v-data-table
          v-if="categories.length > 0"
          :headers="headers"
          :items="categories"
          :items-per-page="-1"
          item-key="PID"
          class="elevation-0"
          hide-default-footer
        >
          <template v-slot:item.DISPLAY_NAME="{ item }">
            <v-text-field
              v-model="item.DISPLAY_NAME"
              :placeholder="item.DAOU_CATEGORY"
              :disabled="savingPid === item.PID"
              dense
              hide-details
              single-line
              @change="saveCategory(item)"
            />
          </template>

          <template v-slot:item.DAOU_CATEGORY="{ item }">
            <span class="grey--text">{{ item.DAOU_CATEGORY || '-' }}</span>
          </template>

          <template v-slot:item.SORT_ORDER="{ item }">
            <v-text-field
              v-model="item.SORT_ORDER"
              type="number"
              :disabled="savingPid === item.PID"
              dense
              hide-details
              single-line
              style="max-width: 100px;"
              @change="saveCategory(item)"
            />
          </template>

          <template v-slot:item.DAOU_STATUS="{ item }">
            <span class="grey--text">{{ item.DAOU_STATUS || '-' }}</span>
          </template>

          <template v-slot:item.LAST_SEEN_AT="{ item }">
            <span class="grey--text text-body-2">{{ formatDate(item.LAST_SEEN_AT) }}</span>
          </template>

          <template v-slot:item.status="{ item }">
            <v-progress-circular
              v-if="savingPid === item.PID"
              indeterminate
              size="18"
              width="2"
              color="primary"
            />
            <v-icon v-else-if="savedPid === item.PID" small color="success">mdi-check-circle</v-icon>
            <span v-else></span>
          </template>
        </v-data-table>

        <v-container v-if="categories.length === 0 && !loading" class="text-center py-8">
          <v-icon size="64" color="grey lighten-1">mdi-tag-off-outline</v-icon>
          <p class="text-body-1 grey--text mt-3">등록된 카테고리가 없습니다.</p>
        </v-container>
      </v-card-text>
    </v-card>

    <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="2500" bottom>
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">닫기</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { coupon } from '../../api';

export default {
  name: 'Coupon_Categories',
  data() {
    return {
      loading: false,
      savingPid: null,
      savedPid: null,
      categories: [],
      snackbar: false,
      snackbarText: '',
      snackbarColor: 'success',
      headers: [
        { text: '표시명', value: 'DISPLAY_NAME', sortable: false, width: '240' },
        { text: '다우 원본명', value: 'DAOU_CATEGORY', sortable: false, width: '200' },
        { text: '정렬', value: 'SORT_ORDER', sortable: false, width: '120' },
        { text: '상태', value: 'DAOU_STATUS', sortable: false, width: '120' },
        { text: '최근확인', value: 'LAST_SEEN_AT', sortable: false, width: '180' },
        { text: '', value: 'status', sortable: false, width: '60', align: 'center' },
      ],
    };
  },
  mounted() {
    this.loadCategories();
  },
  methods: {
    loadCategories() {
      this.loading = true;
      coupon.getCategories()
        .then((res) => {
          const list = (res && res.categories) || [];
          this.categories = list.map((row) => ({
            PID: row.PID,
            DAOU_CATEGORY: row.DAOU_CATEGORY,
            DISPLAY_NAME: row.DISPLAY_NAME || '',
            SORT_ORDER: row.SORT_ORDER === null || row.SORT_ORDER === undefined ? 0 : row.SORT_ORDER,
            DAOU_STATUS: row.DAOU_STATUS,
            LAST_SEEN_AT: row.LAST_SEEN_AT,
          }));
        })
        .catch((e) => {
          alert(typeof e === 'string' ? e : '불러오지 못했습니다.');
        })
        .finally(() => { this.loading = false; });
    },
    saveCategory(item) {
      if (!item || this.savingPid === item.PID) return;
      this.savingPid = item.PID;
      this.savedPid = null;
      const sort = parseInt(item.SORT_ORDER, 10);
      const body = {
        display_name: (item.DISPLAY_NAME || '').trim(),
        sort_order: isNaN(sort) ? 0 : sort,
      };
      coupon.updateCategory(item.PID, body)
        .then(() => {
          item.SORT_ORDER = body.sort_order;
          item.DISPLAY_NAME = body.display_name;
          this.savedPid = item.PID;
          this.showSnackbar('저장되었습니다.', 'success');
        })
        .catch((e) => {
          this.showSnackbar(typeof e === 'string' ? e : '저장에 실패했습니다.', 'error');
        })
        .finally(() => { this.savingPid = null; });
    },
    showSnackbar(text, color) {
      this.snackbarText = text;
      this.snackbarColor = color || 'success';
      this.snackbar = true;
    },
    formatDate(value) {
      if (!value) return '-';
      const d = new Date(value);
      if (isNaN(d.getTime())) return String(value);
      const p = (n) => (n < 10 ? '0' + n : '' + n);
      return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`;
    },
  },
};
</script>
